import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Avatar, Container, Paper } from "@mui/material";
import logo from "../static/images/logo-mbrdi.svg";
import { navMenu } from "../helpers/constant";
import { useAppSelector } from "../helpers/hooks";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./navigation.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useAppDispatch } from "../helpers/hooks";

const drawerWidth = 240;

const userInitialState = {
  dateOfBirth: "",
  dateOfJoining: "",
  department: "",
  designation: "",
  employeeId: "",
  id: "",
  imageName: "",
  lastSwiftUpdate: "",
  manager: "",
  shortId: "",
  userEmail: "",
  userName: "",
  userType: "",
};

const NavigationBar = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const users = useAppSelector((state) => state.userProfile.users);
  const [allUsersData, setAllUsersData] = React.useState([]);
  const [suggestedUsers, setSuggestedUsers] = React.useState([
    userInitialState,
  ]);
  const [searchValue, setSearchValue] = React.useState("");
  const [showSearchBox, setShowSearchBox] = React.useState(false);
  const user = useAppSelector((state) => state.userProfile.profile);
  const allUsers = useAppSelector((state) => state.userProfile.users);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [activeMenu, setActiveMenu] = React.useState<string | null>(null);


  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, title: string) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(title);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  }; 

  const handleDrawerToggle = () => {
    setMobileOpen((prevState: Boolean) => !prevState);
  };

  React.useEffect(() => {
    setAllUsersData(users);
  }, [users]);

  const handleSearchInput = (e: any) => {
    const value: string = e.target.value;
    setSearchValue(value);
    if (value && value.length > 0) {
      const filteredUserData = allUsers.filter(
        (user: typeof userInitialState) => {
          return (
            user?.userName?.toLowerCase().includes(value.toLowerCase()) ||
            user?.shortId?.toLowerCase().includes(value.toLowerCase())
          );
        }
      );
      setSuggestedUsers(filteredUserData);
    } else {
      setSuggestedUsers([]);
    }
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <Avatar
          alt="logo"
          src={logo}
          sx={{ m: 1, borderRadius: 0, width: "240px", height: "50px" }}
        />
      </Typography>
      <Divider />
      <List>
        {navMenu.map((page) => {
          if (page.title === "Dashboard" && user?.userType !== "ADMIN") return null;
          // if (page.title === "Manage Events" && user?.userType !== "ADMIN") return null;
          // DROPDOWN ITEMS (flatten for mobile)
          if (page.children) {
            return (
              <React.Fragment key={page.title}>
                <ListItem>
                  <ListItemText primary={page.title} />
                </ListItem>
                {page.children.map((child) => (
                  <ListItem
                    key={child.link}
                    component={RouterLink}
                    to={child.link}
                    disablePadding
                  >
                    <ListItemButton sx={{ pl: 4 }}>
                      <ListItemText primary={child.title} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </React.Fragment>
            );
          }

          return (
            <ListItem
              key={page.link}
              component={RouterLink}
              to={page.link}
              disablePadding
            >
              <ListItemButton>
                <ListItemText primary={page.title} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  const hideSearchBox = (hide: boolean) => {
    if (!hide) {
      setSearchValue("");
      setTimeout(() => {
        setShowSearchBox(hide);
      }, 800);
    } else {
      setShowSearchBox(hide);
    }
  };

  return (
    <Container maxWidth={false} disableGutters className="header-navigation">
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="sticky"
          component="nav"
          sx={{ background: "#000000", boxShadow: "none" }}
        >
          <Toolbar sx={{ padding: "0.2rem 0" }}>
            <Avatar
              alt="logo"
              src={logo}
              sx={{
                m: "0.6rem",
                borderRadius: 0,
                width: "229px",
                height: "50px",
                cursor: "pointer",
                marginLeft: "38px",
              }}
              component={RouterLink}
              to={"/"}
            />

            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", sm: "flex" },
                justifyContent: "flex-end",
              }}
            >
             {navMenu.map((page) => {
                // if (page.title === "Dashboard" && user?.userType !== "ADMIN") return null;
                if (page.title === "Manage Events" && user?.userType !== "ADMIN") return null;
                if (page.children) {
                  return (
                    <React.Fragment key={page.title}>
                      <Button
                        onClick={(e) => handleOpenMenu(e, page.title)}
                        sx={{
                          color: "#fff",
                          mr: "2.39rem",
                          textTransform: "none",
                          fontWeight: 300,
                        }}
                        endIcon={
                          activeMenu === page.title ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )
                        }
                      >
                        <Typography sx={{ fontSize: "18px" }}>
                          {page.title}
                        </Typography>
                      </Button>

                      <Menu
                        anchorEl={anchorEl}
                        open={activeMenu === page.title}
                        onClose={handleCloseMenu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        {page.children.map((child) => (
                          <MenuItem
                            key={child.link}
                            onClick={() => {
                              handleCloseMenu();
                              navigate(child.link);
                            }}
                          >
                            {child.title}
                          </MenuItem>
                        ))}
                      </Menu>
                    </React.Fragment>
                  );
                }

                return (
                  <Button
                    key={page.link}
                    component={RouterLink}
                    to={page.link}
                    sx={{
                      color: "#fff",
                      mr: "2.39rem",
                      textTransform: "none",
                      fontWeight: 300,
                    }}
                  >
                    <Typography sx={{ fontSize: "18px" }}>
                      {page.title}
                    </Typography>
                  </Button>
                );
              })}
              <div
                onMouseOver={() => hideSearchBox(true)}
                onMouseLeave={() => hideSearchBox(false)}
                className="searchBox"
                style={{
                  position: "absolute",
                  bottom: 9,
                  right: 12,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {showSearchBox ? (
                  <Autocomplete
                    id="userSearch"
                    value={searchValue}
                    inputValue={searchValue}
                    open={searchValue !== "" ? true : false}
                    disablePortal
                    disableClearable
                    blurOnSelect
                    noOptionsText={
                      searchValue !== "" && (
                        <Typography color={"#ddd"}>No users found</Typography>
                      )
                    }
                    options={suggestedUsers.map((option) => option.shortId)}
                    getOptionLabel={(option) => option}
                    onInputChange={(e) => handleSearchInput(e)}
                    filterOptions={(filteredOptions) => filteredOptions}
                    onChange={(e, v) => {
                      setShowSearchBox(false);
                      navigate("/my-profile", {
                        replace: true,
                        state: { shortid: v },
                      });
                      setSearchValue("");
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "#363636",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "grey",
                        },
                        "&:hover fieldset": {
                          borderColor: "white",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "white",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="especieField"
                        size="medium"
                        label="Enter name or short id"
                        variant="filled"
                        onChange={(event) => {
                          if (event.target.value !== null) {
                            setSearchValue(event.target.value);
                          }
                        }}
                        InputLabelProps={{
                          style: {
                            color: "grey",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            color: "white",
                          },
                        }}
                      />
                    )}
                    PaperComponent={(props) => (
                      <Paper
                        elevation={8}
                        style={{ fontSize: "10px" }}
                        sx={{
                          background: "black",
                          color: "white",
                          fontSize: "25px",
                          "&:hover": {
                            border: "1px solid #ddd",
                            color: "white",
                            backgroundColor: "black",
                          },
                        }}
                        {...props}
                      />
                    )}
                  />
                ) : (
                  <Box sx={{ display: { justifyContent: "flex-end" } }}>
                    <SearchIcon />
                  </Box>
                )}
              </div>
            </Box>
            <Box
              sx={{
                display: {
                  flexGrow: 1,
                  sm: "none",
                  justifyContent: "flex-end",
                },
              }}
            >
              <div
                onMouseOver={() => hideSearchBox(true)}
                onMouseLeave={() => hideSearchBox(false)}
                className="smallSearchBox"
                style={{
                  position: "absolute",
                  bottom: 14,
                  right: 24,
                  display: "flex",
                  backgroundColor: "#000",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {showSearchBox ? (
                  <Autocomplete
                    id="userSearch"
                    value={searchValue}
                    inputValue={searchValue}
                    open={searchValue !== "" ? true : false}
                    disablePortal
                    disableClearable
                    blurOnSelect
                    noOptionsText={
                      searchValue !== "" && (
                        <Typography color={"#ddd"}>No users found</Typography>
                      )
                    }
                    options={suggestedUsers.map((option) => option.shortId)}
                    getOptionLabel={(option) => option}
                    onInputChange={(e) => handleSearchInput(e)}
                    filterOptions={(filteredOptions) => filteredOptions}
                    onChange={(e, v) => {
                      setShowSearchBox(false);
                      navigate("/my-profile", {
                        replace: true,
                        state: { shortid: v },
                      });
                      setSearchValue("");
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "#363636",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "grey",
                        },
                        "&:hover fieldset": {
                          borderColor: "white",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "white",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="especieField"
                        size="medium"
                        label="Short Id"
                        variant="filled"
                        onChange={(event) => {
                          if (event.target.value !== null) {
                            setSearchValue(event.target.value);
                          }
                        }}
                        InputLabelProps={{
                          style: {
                            color: "grey",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            color: "white",
                          },
                        }}
                      />
                    )}
                    PaperComponent={(props) => (
                      <Paper
                        elevation={8}
                        style={{ fontSize: "10px" }}
                        sx={{
                          background: "black",
                          color: "white",
                          fontSize: "25px",
                          "&:hover": {
                            border: "1px solid #ddd",
                            color: "white",
                            backgroundColor: "black",
                          },
                        }}
                        {...props}
                      />
                    )}
                  />
                ) : (
                  <Box
                    sx={{
                      display: { flexGrow: 1, justifyContent: "flex-end" },
                    }}
                  >
                    <SearchIcon />
                  </Box>
                )}
              </div>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { sm: "none" }, float: "right", mr: "2%" }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </>
      </Box>
    </Container>
  );
};
export default NavigationBar;
